import { Component, Input, OnInit } from '@angular/core';
import { EChartsOption } from 'echarts';
import { NumberSuffixPipe } from 'src/app/core/filters/numberSuffix-pipe';
import { SalesService } from '../../EBU/services/sales.service';

@Component({
  selector: 'app-top5-chart',
  templateUrl: './top5-chart.component.html',
  styleUrls: ['./top5-chart.component.scss'],
})
export class Top5ChartComponent implements OnInit {
  @Input() top5: any = {};
  @Input() button: any = {};
  option: EChartsOption = {};
  title: string = 'Top 5';
  current: any = [];
  base: any = [];
  by: any = [];
  constructor(private service: SalesService) {}
  ngOnInit(): void {
    this.getChart();
  }
  getChart() {
    switch (this.button) {
      case 'engine_model':
        this.title = 'Top 5 Engine By Sales';
        break;
      case 'certification':
        this.title = 'Top 5 Certification By Sales';
        break;
      case 'ecc':
        this.title = 'Top 5 ECC By Sales';
        break;
      case 'parts':
        this.title = 'Top 5 Parts By Sales';
        break;
      case 'lob_l2':
        this.title = 'Top 5 LOB - L2 By Sales';
        break;
      default:
    }
    this.top5.reverse().map((name: any) => {
      this.current.push(name.current_period_sales);
      this.base.push(name.prior_period_sales);
      this.by.push(name[this.button]);
    });
    this.option = {
      color: ['#273D98', '#E56B32'],

      title: {
        text: this.title,
        left: 'center',
        textStyle: {
          color: '#000000',
          fontSize: '14px',
        },
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
        formatter: function (params: any) {
          let value1 = params[0].value.toLocaleString(undefined, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          });
          let value2 = params[1].value.toLocaleString(undefined, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          });

          return (
            params[0].axisValue +
            '<br>' +
            params[0].marker +
            params[0].seriesName +
            ' : ' +
            value1 +
            '</br>' +
            params[1].marker +
            params[1].seriesName +
            ' : ' +
            value2
          );
        },
      },
      legend: {
        orient: 'horizontal',
        top: 25,
        itemWidth: 12,
        itemHeight: 12,
      },
      grid: {
        left: '1%',
        right: '10%',
        bottom: '3%',
        containLabel: true,
      },
      xAxis: {
        type: 'value',
        // boundaryGap: [0, 0.01],
        splitLine: {
          show: false,
        },
        axisLabel: {
          show: false,
          formatter: function (xAxis, d) {
            return NumberSuffixPipe.prototype.transform(xAxis, 0);
          },
          fontSize: '9px',
        },
      },
      yAxis: {
        type: 'category',
        data: this.by,
        axisLabel: {
          color: 'black',
          //fontWeight: 'bold',
          fontSize: 13,
        },
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
      },
      series: [
        {
          name: '2025',
          type: 'bar',
          barWidth: 26,
          barGap: 0,
          data: this.base,
          label: {
            show: true,
            position: 'outside',
            formatter: function (d: any): any {
              return NumberSuffixPipe.prototype.transform(d.data, 1);
            },

            color: 'black',
            fontWeight: 'bold',
            fontSize: 12,
          },
        },
        {
          name: '2026',
          type: 'bar',
          barWidth: 26,
          data: this.current,
          label: {
            show: true,
            position: 'outside',
            formatter: function (d: any): any {
              return NumberSuffixPipe.prototype.transform(d.data, 1);
            },
            color: 'black',
            fontWeight: 'bold',
            fontSize: 12,
          },
        },
      ],
    };
  }
}
